import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { EnterpriseCustomerSelectionCard } from "../components/EnterpriseCustomerState";
import { RoiVsSpendPanel } from "../components/RoiVsSpendPanel";
import { ensureEnterpriseCustomerContext } from "../lib/enterpriseCustomerContext";
import { enterpriseOverviewQueryOptions } from "../queries/useGetEnterpriseOverview";
import { roiVsSpendQueryOptions } from "../queries/useGetRoiVsSpend";

function AssetsRouteComponent() {
  const { t } = useTranslation();
  const { externalCustomerId } = Route.useSearch();
  if (!externalCustomerId) {
    return (
      <EnterpriseCustomerSelectionCard
        title={t("enterprise.common.selectCustomerTitle")}
        description={t("enterprise.roi.customerSelectionDescription")}
      />
    );
  }
  return <RoiVsSpendPanel externalCustomerId={externalCustomerId} />;
}

export const Route = createFileRoute("/_app/assets")({
  loaderDeps: ({ search }) => ({
    externalCustomerId: search.externalCustomerId,
  }),
  loader: async ({ context, deps }) => {
    if (!deps.externalCustomerId) {
      return;
    }

    const customer = await ensureEnterpriseCustomerContext(
      context.queryClient,
      deps.externalCustomerId,
    );

    await Promise.all([
      context.queryClient.ensureQueryData(
        enterpriseOverviewQueryOptions(customer.customerId),
      ),
      context.queryClient.ensureQueryData(
        roiVsSpendQueryOptions(customer.customerId),
      ),
    ]);
  },
  component: AssetsRouteComponent,
});
